export const GetCardTextColor = (typeOfCard) => {
  switch (typeOfCard) {
    case 'Truth':
      return '#A63348';
    case 'Light Dare':
      return '#ffbfe5ff';
    case 'Dare':
      return '#ffbfe5';
    case 'Kinky Dare':
      return '#ffbfe5';
    default:
      return '#ffbfe5';
  }
};
